export default __webpack_public_path__ + "static/media/4.ac6b8229.jpg";